<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <!-- <van-tabs v-model="active" @change="handleClick">
      <van-tab title="已归档"></van-tab>
      <van-tab title="借阅中"></van-tab>
      <van-tab title="已作废"></van-tab>
    </van-tabs> -->
    <van-tabs v-model="active" @change="handleClick" :ellipsis="false">
      <van-tab title="执行中" :badge="contCount.execSum != 0?contCount.execSum:''" name="2"></van-tab>
      <van-tab title="即将到期" :badge="contCount.soonSum != 0?contCount.soonSum:''" name="1"></van-tab>
      <van-tab title="合同过期" :badge="contCount.expireSum != 0?contCount.expireSum:''" name="3"></van-tab>
      <van-tab title="全部" :badge="contCount.allSum != 0?contCount.allSum:''" name="99"></van-tab>
      <van-tab title="已续签" :badge="contCount.renewalSum != 0?contCount.renewalSum:''" name="5"></van-tab>
      <van-tab title="合同完成" :badge="contCount.completeSum != 0?contCount.completeSum:''" name="4"></van-tab>
      <van-tab title="作废" :badge="contCount.cancelSum != 0?contCount.cancelSum:''" name="6"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <list-item @todetail="toDetails" :listData="list" :typeCont="'query'" />
    </van-list>
    <empty-component v-if="isEmpty" />
  </div>
</template>

<script>
import moment from 'moment'
import newContract from '@/api/cont/newContract'
import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import SearchPop from '../components/contract/SearchPop.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import ListItem from '../components/contract/ListContractItem.vue'
import { Tab, Tabs } from 'vant'
export default {
  name: 'approve',
  components: {
    SearchComponent,
    SearchPop,
    EmptyComponent,
    TotalComponent,
    ListItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  filters: {
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      deptTreeList: [],
      add_show: false,
      isEmpty: false,
      active: 0,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      showFilterPop: false,
      options: {},
      custList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractNum: '',
        contractName: '',
        serviceTypeId: '',
        contractStatus: 7,
        executionStatus: 2
        // orderByColumn: 'createTime',
        // isAsc: 'desc'
      },
      contCount: {}
    }
  },
  async created() {
    // 合同模板
    await getDicts('template_type').then(res => {
      this.options.templateTypeOptions = res.data
    })
    // 框架类型
    await getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 垫款方式
    await getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    // 合同状态
    await getDicts('contract_status').then(res => {
      this.options.contractStatusOptions = res.data
    })
    // 框架类型
    await getDicts('cust_source').then(res => {
      this.options.custSourceOptions = res.data
    })
    await this.handleList()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '归档合同查询'
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.queryParams.contractName = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      this.$router.push({
        path: '/cont/approve/detail',
        query: { id: item.contractId, active: this.active }
      })
    },
    async handleList() {
      this.loading = true
      const res = await newContract.getConContractExportList(this.queryParams)

      if (res.code === 200) {
        console.log(res)
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
      this.listSum()
    },
    listSum() {
      newContract.getContractSum({ ...this.queryParams, executionStatus: null }).then(res => {
        if (res.code === 200) {
          this.contCount = res.data
        }
      })
    },
    onLoad() {
      this.handleList()
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    handleClick(tab, event) {
      // if (tab == '0') {
      //   this.queryParams.contractStatus = 7
      // } else if (tab == '1') {
      //   this.queryParams.contractStatus = 9
      // } else if (tab == '2') {
      //   this.queryParams.contractStatus = 30
      // }
      if (tab == 99) {
        this.queryParams.executionStatus = null
      } else {
        this.queryParams.executionStatus = tab
      }
      this.queryCustList()
    },
    handleAddContract() {
      this.add_show = true
    },
    handleAddContractCancel() {
      this.add_show = false
    },
    // 添加合同
    async addContractBeforeClose() {
      this.add_show = false
      await this.queryCustList()
      // let _this = this;
      // // if (type === "confirm") {
      // //   try {
      //     // await this.$refs["form"].validate();
      //     addContract(form).then((response) => {
      //       if(response.code == 200){
      //         Toast.success("添加成功");
      //         _this.add_show = false;
      //       }else{
      //         Toast.fail("添加失败:"+response.msg);
      //       }
      //     });
      //     setTimeout(() => {
      //       _this.queryContractList();
      //     },500)
      //     // done();
      //   // } catch (err) {
      //   //   return done(false);
      //   // }
      // //   return done(false);
      // // } else {
      // //   return done();
      // // }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
</style>
